/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-02 19:47:42
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-13 09:16:02
 */

const sys = [
    {
        path: '/my',
        name: 'my',
        component: () => import('../views/my/index.vue'),
    },
    {
        path: '/tool/:appid',
        name: 'tool',
        component: () => import('../views/tool/tool.vue'),
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('../views/tool/test.vue'),
    },
    {
        path: '/activity/:id/:type?',
        name: 'activity',
        component: () => import('../views/banner/detail.vue'),
    },
]
export default sys


// WEBPACK FOOTER //
// ./src/router/sys.js